import type { ChartType } from "@foodpilot/foods";
import { DimensionValue } from "src/api/client-api/olapScores/olapScoresSchema";
import { OlapScoresService } from "src/context/OlapScores/OlapScoresService";

export type DatavizType = "donut" | "bar" | "line" | "pie" | "radar" | "table" | "raw";

export const buildMaxScoreArray = (labels: readonly string[], subHeadings?: DimensionValue[] | null): number[] => {
    if (!subHeadings) return [];

    const byLabel = new Map<string, number>();
    for (const dimensionValue of subHeadings) {
        const value = OlapScoresService.normalizeNumericalScore(dimensionValue.score.value, 0);
        byLabel.set(dimensionValue.label, value);
    }

    return labels.map((label) => byLabel.get(label) ?? 0);
};

export const ALLOWED_CHART_TYPES: readonly DatavizType[] = [
    "donut",
    "bar",
    "line",
    "pie",
    "radar",
    "table",
    "raw",
] as const;

export const isAllowedChartType = (t: unknown): t is DatavizType =>
    typeof t === "string" && (ALLOWED_CHART_TYPES as readonly string[]).includes(t);

export const resolveChartType = (
    datavizType: DatavizType | undefined,
    fallback: ChartType | DatavizType = "donut",
): ChartType => (isAllowedChartType(datavizType) ? (datavizType as ChartType) : (fallback as ChartType));
